import React, { useState } from 'react';

const faqs = [
    {
        question: "What Services does Code Buddy's IT company provide?",
        answer:
            "Code Buddy's IT company provides a wide range of services including software development, web development, mobile app development, UI/UX design, quality assurance, cloud computing, and IT consulting.",
    },
    {
        question: "What technologies does Code Buddy’s specialize in?",
        answer:
            "Code Buddy's specializes in a diverse range of technologies including but not limited to Java, Python, JavaScript, Ruby on Rails, PHP, Android, React, Shopify and Laravel.",
    },
    {
        question: "How does Code Buddy’s ensure timely delivery of projects?",
        answer:
            "We follow an agile development methodology, which allows us to deliver incremental updates and maintain constant communication with our clients. We set realistic project timelines and ensure that our team adheres to them, minimizing any delays.",
    },
    {
        question: "How experienced is the team at Code Buddy’s?",
        answer:
            "The team at Code Buddy's is composed of highly skilled professionals with extensive experience. Our developers and designers have a proven track record across various industries.",
    },
    {
        question: "Can Code Buddy's handle both small and large projects?",
        answer:
            "Absolutely! Code Buddy's has experience in handling projects of varying sizes—from small start-up projects to large enterprise-level applications.",
    },
    {
        question: "How does Code Buddy's maintain support for clients?",
        answer:
            "Code Buddy's provides ongoing support after project completion through technical support, regular maintenance updates, and responsive communication.",
    },
];

const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section>
            <div className="faq-header">
                <h1>FAQ</h1>
                <h2>Frequently Asked Questions</h2>
                <p>Browse FAQs or reach out for assistance.</p>
            </div>

            <div className="faq-container">
                {/* Questions */}
                <div className="faq-questions">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                        >
                            <div className="question-indicator">
                                <img src={process.env.PUBLIC_URL + "/images/Vector.png"} alt="Expand Icon" />
                                
                            </div>
                            {faq.question}
                        </div>
                    ))}
                </div>

                {/* Answers */}
                <div className="faq-answers">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-answer ${activeIndex === index ? 'active' : ''}`}
                        >
                            <div className="answer-bubble">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/double cote.png"}
                                    alt="Quote Icon"
                                    className="quote-icon"
                                />
                                <p className="answer-text">{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
